import { Trans } from '@lingui/react/macro';
import { Banner } from 'components/banner/banner';
import { CheckRoundedIcon } from 'components/icons/CheckRoundedIcon';

export const ConnectionEstablishedBanner = () => (
  <Banner
    icon={<CheckRoundedIcon fontSize="medium" sx={{ marginRight: 1 }} />}
    title={
      <Trans>
        Votre connexion extracteur est <strong>opérationnelle</strong>.
      </Trans>
    }
    color="success"
    sx={{ maxWidth: { lg: '40%' }, mt: 2 }}
  />
);
